module.exports = __webpack_public_path__ + "static/media/booking-sold-out.6d317e60.png";